import { useCallback } from 'react'
import { useQueryParams } from 'use-query-params'
import { stringQueryParamEncoder } from 'utils/query-params/string.utils'

export const useCollectionsListQueryParams = () => {
  const [queryParams, setQueryParams] = useQueryParams({
    collectionName: stringQueryParamEncoder,
    status: stringQueryParamEncoder,
    collectionType: stringQueryParamEncoder,
    source: stringQueryParamEncoder,
  })

  const setCollectionName = useCallback(
    (collectionName: string) => {
      setQueryParams({
        collectionName,
      })
    },
    [setQueryParams]
  )

  const setStatus = useCallback(
    (status: string) => {
      setQueryParams({
        status,
      })
    },
    [setQueryParams]
  )

  const setCollectionType = useCallback(
    (collectionType: string) => {
      setQueryParams({
        collectionType,
      })
    },
    [setQueryParams]
  )

  const setSource = useCallback(
    (source: string) => {
      setQueryParams({
        source,
      })
    },
    [setQueryParams]
  )

  return {
    queryParams,
    setCollectionName,
    setStatus,
    setCollectionType,
    setSource,
  }
}
